// extracted by mini-css-extract-plugin
export default {"ItemsPerPageSelector":"ItemsPerPageSelector_ItemsPerPageSelector__z18Ft"};